<template>
    <div class="inventory d-flex flex-column">
        <div>
            <div class="navigator">
                <h2 class="mr-auto">My Inventory</h2>

                <!-- <dropdown-button :options="options" label="Add new"></dropdown-button> -->
            </div>
        </div>

        <div class="flexGrow1 overflow-auto">
            <tabs @changed="tabChanged">
                <tab name="Products">
                    <products></products>
                </tab>
                <tab name="Services">
                    <extras></extras>
                </tab>
                <tab name="Resources">
                    <resources></resources>
                </tab>


                <!-- *** This will not be available for customer, we want all companies to have our categories.***  -->
                <tab name="Categories">
                    <categories></categories>
                </tab>
                <tab name="Transports">
                    <transports></transports>
                </tab>
                <!--
                <tab name="Pick-ups">
                    <empty></empty>
                </tab>
                <tab name="Promocodes">
                    <empty></empty>
                </tab>
                -->
            </tabs>
        </div>
    </div>
</template>

<script>
    // notes:
    // services where extras before, thats why all files ralated are called extras

    import { mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Empty from '@/tools/Empty'
    import Products from './Products'
    import Extras from './Extras'
    import Resources from './Resources'
    import Categories from './Categories'
    import Transports from './transports/Transports'
    import DropdownButton from '../common/DropdownButton'

    export default {
        data: function() {
            return {
                options: [],
                initTabsHelper: {}
            }
        },
        created: function() {
            this.init();

            this.options = [
                { label: 'Product', fn: this.openForm, value: 'ProductNew' },
                { label: 'Service', fn: this.openModal, value: 'ExtraAdd' },
                { label: 'Resource', fn: this.openModal, value: 'ResourceAdd' },
                { label: 'Category', fn: this.openModal, value: 'CategoryAdd' }
            ];
        },
        mounted: function() {
            //prevents passing data from edit to create pages
            this.clearSelectedItem();
            this.clearClonedItem();
        },
        methods: {
            ...mapActions([
                'openModal',
                'initProducts',
                'initExtras',
                'initResources',
                'initCategories',
                'refreshAccountData',
                'clearSelectedItem',
                'clearClonedItem'
            ]),
            async init() {
                // await this.refreshAccountData().then(() => {
                //     // this.initResources();
                //     // this.initExtras();
                //     // this.initCategories();
                //     // this.initProducts();
                // });
            },
            openForm: function() {
                this.$router.push({ name: 'pluralo.product.new' });
            },
            tabChanged: function(e) {
                //this allows to start loading tabs independently and with a time buffer between loads
                this.initTab(e.tab.name)
            },
            initTab: function(tabName){
                if(this.initTabsHelper[tabName]){
                    let diff = moment().diff(moment(this.initTabsHelper[tabName].initializedAt), 'minutes')
                    console.log('This tab was visited ' + diff+ ' minute(s) ago');

                    // this sets the time that needs to pass to trigger a new load
                    if(diff > 2){
                        this.loadTabContent(tabName)
                    }

                } else{
                    this.loadTabContent(tabName)
                }
                // if(this.initTabsHelper[tabName] && this.initTabsHelper[tabName].initializedAt)

                this.$set(this.initTabsHelper, tabName, {
                    initialized: true,
                    initializedAt: moment()
                })
            },
            loadTabContent: function(tabName) {
                switch (tabName) {
                    case 'Products':
                        this.initProducts();
                        break;

                    case 'Services':
                        this.initExtras();
                        break;

                    case 'Resources':
                        this.initResources();
                        break;

                    case 'Categories':
                        this.initCategories();
                        break;

                    default:

                }
            }
        },
        components: {
            List,
            Empty,
            Products,
            Extras,
            Resources,
            Categories,
            Transports,
            DropdownButton
        },
    }

</script>



// WEBPACK FOOTER //
// Inventory.vue?92301c6e